<template>
    <div class="element-box el-tablo">
        <div class="label">
            {{ label }}
        </div>
        <div class="value">
            {{ value }}
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  value: {
    type: [String, Number],
    default: '',
    required: true,
  },
  label: {
    type: String,
    default: '',
    required: true,
  },
});
</script>

<style></style>